export enum VehicleTypeDTO {
  CAR = "car",
  BIKE = "bike",
}

export type FetchItemsParamsDTO = {
  vehicleType: VehicleTypeDTO;
  actualPage?: number;
  displayPerPage?: number;
  order?: string;
  url: string;
  mediaZeroKm?: boolean;
  channel?: string;
  showResult?: boolean;
  showRegionalized?: boolean;
  showMenu?: boolean;
  showMenuGrouped?: boolean;
  showCount?: boolean;
  showBreadCrumb?: boolean;
};
